export default __webpack_public_path__ + "static/media/1560.ec82c9a8.png";